import request from '../untils/request';

export const operationArchiveListApi = params => {
  return request({
    url: '/operation/archive/index',
    authCode: 'DOCMENT_INDEX',
    params,
  });
};

export const operationArchiveSaveApi = params => {
  return request({
    url: '/operation/archive/save',
    authCode: 'DOCMENT_EDIT',
    params,
  });
};

export const operationArchiveDeleteApi = params => {
  return request({
    url: '/operation/archive/delete',
    authCode: 'DOCMENT_EDIT',
    params,
  });
};

export const operationArchiveDetailApi = params => {
  return request({
    url: '/operation/archive/detail',
    authCode: 'DOCMENT_EDIT',
    params,
  });
};
